<template>
  <div id="footer" class="container-fluid">
    <p class="title">四川明槊科技有限公司</p>
     <div class="flex flex-center" style="height: 80px;margin-left: 40px">
       <div>
         <img src="@/assets/img/yyapp.png" alt="" style="width: 80px;height: auto">
         <text>扫码下载app</text>
       </div>
       <div style="margin-left: 40px">
         <img src="@/assets/img/xcx.png" alt="" style="width: 80px;height: auto">
         <text>扫码进入小程序</text>
       </div>
     </div>
    <div>
      <p class="address_tel_fax">
        <span>地址：四川省遂宁市船山区明星大道245号</span>
      </p>
      <p class="email_wx">
        <span>邮箱：mingshuokeji@163.com</span>
        <span>Tel：400-9633-988</span>
      </p>
      <p class="copy">
       Copyright &copy; 2018 - 2022 四川明槊科技有限公司 &nbsp;&nbsp;
        <img  style="width: 18px;margin-right: 5px" src="data:image/png;base64,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">
        <a id="domain" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="beian" >
          蜀ICP备20024092号-1
        </a>
        <img style="width: 18px;margin-right: 5px" src="data:image/png;base64,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">
          <a id="domain" href="https://www.beian.gov.cn/portal/recordQuery" target="_blank" class="beian" >
          川公网安备 51090302000261号
        </a>
        </p>
    </div>

  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #0A167A;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin:10px 0 10px;
  display: flex;
  justify-content: center;
}
.beian{
  font-size: 14px;
  text-decoration: none;
  color: #007aff!important;
  cursor: pointer;
  margin-right: 5px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 10px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue